import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_COMMERCIAL_MANAGEMENT_REQUEST,
  FETCH_COMMERCIAL_MANAGEMENT_SUCCESS,
  FETCH_COMMERCIAL_MANAGEMENT_ERROR,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST,
  FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS
} from 'actionTypes'

/*
 * REQUEST COMMERCIAL_MANAGEMENTS
 */


export const fetchCommercialManagementsReport = (auth,filters,callback, signalController) => (dispatch) => {
  dispatch(fetchCommercialManagementsReportSuccess())
  const params = { ...filters}

  const onClose = () => {
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  const onError = (error) => {
    dispatch(fetchCommercialManagementsReportError(error))
    onClose()
  }
  
  const onMessage = (response) => {
    dispatch(fetchCommercialManagementsReportSuccess(response.data.commercialManagement, params))
    callback(response.data)
    dispatch(hideSpinner())
  }

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  }

  dispatch(showSpinner("", true,abort))

  return new Api(auth.user.dsToken, dispatch)
  .eventSourceStream(API_URL.COMMERCIAL_MANAGEMENT_REPORT, params, null, signalController, onMessage, onClose, onError)
  .catch((error) => onError(error))
}

export const fetchCommercialManagements = (auth, filters) => (dispatch) => {
  dispatch(fetchCommercialManagementsRequest())

  /* istanbul ignore else */
  if (!filters || !filters.idBranch) {
    filters = {
      ...filters,
      idBranch: auth.user.locationCode,
    }
  }

  const params = {
    ...filters,
  }

  return new Api(auth.user.dsToken, dispatch)
    .post(API_URL.COMMERCIAL_MANAGEMENTS, params)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(fetchCommercialManagementsSuccess(response.data))
      dispatch(hideSpinner())
    })
    .catch((error) => {
      dispatch(fetchCommercialManagementsReportError(error))
      dispatch(hideSpinner())
    })
}

export const fetchCommercialManagementsRequest = () => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_REQUEST,
})

export const fetchCommercialManagementsSuccess = (data, filters) => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_SUCCESS,
  payload: data,
  filters,
})

export const fetchCommercialManagementsError = (error) => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_ERROR,
  payload: error,
})


export const fetchCommercialManagementsReportRequest = () => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_REPORT_REQUEST,
})

export const fetchCommercialManagementsReportSuccess = (data) => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_REPORT_SUCCESS,
  payload: data,
})

export const fetchCommercialManagementsReportError = (error) => ({
  type: FETCH_COMMERCIAL_MANAGEMENT_REPORT_ERROR,
  payload: error,
})
